// Input de shadcn, copiado al repo y adaptado al Campo de identidad
// (components/core/Campo.jsx) sobre base slate: fondo hundido (slate 900),
// borde de 1px, radio 6px, foco con borde acero claro y anillo suave. Sin
// aspecto nativo en ningun navegador (styles.css): el fondo y el color son
// siempre los del tema. El estado de error lo marca `aria-invalid`, que es lo
// que lee un lector de pantalla, y el color sale de ahi: no hay dos fuentes de
// verdad para "este campo esta mal".
import { cn } from "./cn.js";

export function Input({
  className,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>): React.JSX.Element {
  return (
    <input
      className={cn(
        "h-10 w-full rounded-md border border-linea-fuerte bg-hundida px-3",
        "font-sans text-base text-texto placeholder:text-texto-debil",
        "transition-[border-color,box-shadow] duration-150 ease-estandar",
        "focus:border-acero-claro focus:shadow-[0_0_0_2px_rgb(37_99_235/0.15)] focus:outline-none",
        "aria-invalid:border-critico",
        "disabled:opacity-45",
        className,
      )}
      {...props}
    />
  );
}

/** Desplegable nativo con el aspecto del Campo: mismo borde, fondo y foco que Input, con la flecha propia. */
export function Select({
  className,
  ...props
}: React.SelectHTMLAttributes<HTMLSelectElement>): React.JSX.Element {
  return (
    <select
      className={cn(
        "desplegable h-10 w-full rounded-md border border-linea-fuerte bg-hundida pl-3 pr-8",
        "font-sans text-base text-texto",
        "transition-[border-color,box-shadow] duration-150 ease-estandar",
        "focus:border-acero-claro focus:shadow-[0_0_0_2px_rgb(37_99_235/0.15)] focus:outline-none",
        "disabled:opacity-45",
        className,
      )}
      {...props}
    />
  );
}
